import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { CancelAdminDeductionRequest } from '@billda/api';
import { cancelAdminDeduction } from '../api/deductionsAdminApi';
import { deductionsKeys } from './useGetDeductions';
import { potKeys } from './potKeys';

/**
 * Mutation hook for cancelling an admin deduction.
 *
 * Errors are handled by the global QueryClient onError (shows snackbar).
 * Callers can override with mutate(data, { onSuccess, onError }).
 */
export function useCancelAdminDeduction() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      deductionId,
      request,
    }: {
      deductionId: string;
      request: CancelAdminDeductionRequest;
    }) => cancelAdminDeduction(deductionId, request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: deductionsKeys.all });
      queryClient.invalidateQueries({ queryKey: potKeys.all });
    },
  });
}
